import { endpoints, type LeadCommentCreate } from '@gopinhos/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../lib/api-client';

export interface LeadCommentView {
  id: string;
  leadId: string;
  authorUserId: string;
  parentCommentId: string | null;
  body: string;
  editedAt: string | null;
  createdAt: string;
  author: { id: string; fullName: string; avatarUrl: string | null };
}

export function useLeadComments(leadId: string | undefined) {
  return useQuery({
    queryKey: ['leadComments', leadId],
    enabled: !!leadId,
    queryFn: () =>
      apiClient.request<unknown, never>({
        method: 'GET',
        path: endpoints.leadComments(leadId!),
      }) as Promise<{ items: LeadCommentView[] }>,
  });
}

export function useCreateLeadComment(leadId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: LeadCommentCreate) =>
      apiClient.request({
        method: 'POST',
        path: endpoints.leadComments(leadId),
        body: input,
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['leadComments', leadId] });
    },
  });
}
